/*
 * Title : GentleProxy Object 
 * Author : KimTaeOh 
 * Email : taeoh.kim@gentlepie.com
 * Description: 서버통신 라이브러리  
 * Property Value
 * @method : HTTP METHOD ( POST|GET )
 * @url : requestUrl
 * @dataType : responseDataType
 * @requestBody : requestData
 * @contentType : requestContentType
 */ 

import GentleProxy from '../common/proxy';
import GentleUtil from '../common/util';
import GentleServiceError from '../service/error';
import GentleAppState from '../common/appstate';
import CryptoJS from "crypto-js";
//import GentleComponentBubble from '../component/bubble';

var GentleApi = Object.create( GentleProxy );
var GentleApi = {
    get method() {
        return this.requestMethod;
    },
    set method(value){
        this.requestMethod = value;
    },
    get url() {
        return this.requestUrl;
    },
    set url(value){
        this.requestUrl = value;
    },
    get dataType(){
        return this.responseDataType;
    },
    set dataType(value){
        this.responseDataType = value;
    },
    get requestBody(){
        return this.requestData;
    },
    set requestBody(value){
        this.requestData = value;
    },
    get contentType(){
        return this.requestContentType;
    },
    set contentType(value){
        this.requestContentType = value;
    },

    sendMutipartFormData: function(obj){
        // var form = $('#uploadForm')[0]
        let {form, url, callback} = obj;
        // console.log('form>', obj);

        if(url === ""){
            url = this.url
        }else{
            url = url
        }
        // console.log("`';`'`'`'`''`", url)

        var data = form
        // console.log("-=-=-=-=-=-=-=", form)
        try{
            var that = this;
            $.ajax({
                type: "POST",
                method: "POST",
                url,
                data: data,
                beforeSend: function (xhr) {
                    if(!!GentleAppState.AtomyUserToken){
                        xhr.setRequestHeader('atomyJwt', GentleAppState.AtomyUserToken)
                    }
                }, // 헤더 설정
                processData: false,
                contentType: false,
                cache: false,
                timeout: 600000,
            })
            .done(function (data, textStatus, xhr) {
                console.log("postSuccess")
                // console.log(data);
                if(callback !== ""){
                    callback(data)

                    if(that.successCallback)
                        that.successCallback(data);
                }
                that.successCallback(data);
                
            })
            .fail(function(data, textStatus, errorThrown){
                // console.log("postFailed")

                if( that.failedCallback == undefined){
                    that.defaultFailedCallback(data);                
                    GentleServiceError.createErrorHandler('service', data);
                }else{
                    that.failedCallback(data);
                } 
            })
            .always(function()
            {
                window.ChatConsole.loadingBox(false);
                GentleUtil.serviceLoadingHide();
                
                if(that.alwaysCallback !== undefined){
                    that.alwaysCallback();
                }
            });
        }
        catch(err){
            console.log('this.errorCallback>', this.errorCallback);
            if(this.errorCallback){
                this.errorCallback();
            }
            else{
                GentleServiceError.createErrorHandler('service', err);
            }
        }
    },
    sendeno: function(){
        try{
            var that = this;
            // console.log('url',this.url);
            // console.log('this.requestBody', this.requestBody);
            console.log('this.contentType', this.contentType);
            const decodedCmd = decodeURIComponent(this.requestBody.split('=')[1]);
            // cmd 데이터를 포함한 객체로 변환
            const dataObj = {
                cmd: JSON.parse(decodedCmd)  // cmd 키를 포함하여 JSON 파싱
            };

            const isEncryptedCUValid = (customerId) => {
                try {
                  const decoded = CryptoJS.enc.Base64.parse(customerId);
                  const ivSize = 16;
                  return decoded.words.length * 4 >= ivSize; 
                } catch {
                  return false;
                }
            };
            // customerId검증
            if (
                navigator.userAgent.includes('curl') ||
                dataObj.cmd?.command === "TalkList" ||
                (dataObj.cmd?.customerId && !isEncryptedCUValid(dataObj.cmd.customerId))
              ) {
                console.log("Invalid request, skipping further processing");
                return; // 잘못된 요청일 경우 처리를 중단
            };

            let data = (this.dataType === undefined)?JSON.stringify(this.requestBody):this.requestBody;
            // console.log("send().this.requestBody",  data)
            // console.log("send().this",  this)
            console.log("this.dataType",  this.dataType)

            if(this.contentType == 'application/x-www-form-urlencoded'){
                data = this.requestBody;
            }else{
                data = JSON.stringify(this.requestBody)
            }
            // if(this.requestUrl === "/atomy-global-post/datomy/getApprovalBalance?_siteId=atomy&apiKey=atomy1234!"){
            //     this.contentType = 'multipart/form-data; charset=UTF-8'
            //     // this.dataType = 'json'
            // }
            $.ajax({
                type: (this.method === undefined)?'GET':this.method,
                url: this.url,

                contentType: (this.contentType === undefined)?'application/json; charset=utf-8':this.contentType,
                // dataType:(this.dataType === undefined)?'json':this.dataType,
                data,
                // data: (this.dataType === undefined)?JSON.stringify(this.requestBody):this.requestBody

                // data: this.requestBody : It works!!!!
            })
            .done(function (data, textStatus, xhr) {
                //const obj = JSON.parse(data);
                // console.log("done data  -> ", data)
                let {StatusCode} = data;
                StatusCode = 500;
                if(StatusCode === 500){
                    // throw "Server Internal Error";
                    // todo : 500 Error handling
                }                

                that.successCallback(data);
            })
            .fail(function(data, textStatus, errorThrown){

                // GentleServiceError.createErrorHandler('service', data);
                // console.log("fail data  -> ", data)
                if( that.failedCallback == undefined){
                    that.defaultFailedCallback(data);                
                    GentleServiceError.createErrorHandler('service', data);
                }else{
                    that.failedCallback(data);
                } 
            })
            .always(function(){
                window.ChatConsole.loadingBox(false);
                GentleUtil.serviceLoadingHide();
                
                if(that.alwaysCallback !== undefined){
                    that.alwaysCallback();
                }
            })
        }catch(err){
            console.log('catch')
            // console.log('this.errorCallback>', this.errorCallback);
            // if(this.errorCallback){
            //     this.errorCallback();
            // }
            // else
            {
                GentleServiceError.createErrorHandler('service', err);
            }
        }    
    },
    send: function(authorization = null){
        // console.log('GentleAppState.AtomyUserToken', GentleAppState.AtomyUserToken);
        try{
            var that = this;
            // console.log('this',that);
            // console.log('this.requestBody', this.requestBody);
            // console.log('this.contentType', this.contentType);

            let data = (this.dataType === undefined)?JSON.stringify(this.requestBody):this.requestBody;
            if(this.contentType == 'application/x-www-form-urlencoded'){
                data = this.requestBody;
            } 

            $.ajax({
                type: (this.method === undefined)?'GET':this.method,
                url: this.url,
                beforeSend: function (xhr) {
                    if(!!GentleAppState.AtomyUserToken){
                        xhr.setRequestHeader('user-token', GentleAppState.AtomyUserToken)
                    }
                },
                contentType: (this.contentType === undefined)?'application/json;charset=utf-8':this.contentType,
                dataType:(this.dataType === undefined)?'json':this.dataType,
                data,
                // data: (this.dataType === undefined)?JSON.stringify(this.requestBody):this.requestBody

                // data: this.requestBody : It works!!!!
            })
            .done(function (data, textStatus, xhr) {
                //const obj = JSON.parse(data);
                // 사용중인 IP 주소 가져오기
                console.log('url>',this.url);
                console.log("done data  -> ", data)
                let {StatusCode} = data;
                StatusCode = 500;
                if(StatusCode === 500){
                    // throw "Server Internal Error";
                    // todo : 500 Error handling
                }                

                that.successCallback(data);
            })
            .fail(function(data, textStatus, errorThrown){

                // GentleServiceError.createErrorHandler('service', data);
                console.log("fail data  -> ", data)
                if( that.failedCallback == undefined){
                    that.defaultFailedCallback(data);                
                    GentleServiceError.createErrorHandler('service', data);
                }else{
                    that.failedCallback(data);
                } 
            })
            .always(function(){
                window.ChatConsole.loadingBox(false);
                GentleUtil.serviceLoadingHide();
                
                if(that.alwaysCallback !== undefined){
                    that.alwaysCallback();
                }
            })
        }catch(err){
            console.log('catch')
            // console.log('this.errorCallback>', this.errorCallback);
            // if(this.errorCallback){
            //     this.errorCallback();
            // }
            // else
            {
                GentleServiceError.createErrorHandler('service', err);
            }
        }    
    },
    onSuccess: function(callback){
        this.successCallback = callback;
    },
    onFailed: function(callback){
        this.failedCallback = callback;
    },
    onError: function(callback){
        this.errorCallback = callback;
    },
    onAlways: function(callback){
        this.alwaysCallback = callback;
    },
    defaultFailedCallback: function(data){
        console.log('Server Error!!');
        console.log(data);
    }
}

export default GentleApi;